import React from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "../locales/i18n";
import "leaflet/dist/leaflet.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ReduxProvider store={store}>
    <App />
    <ToastContainer />
  </ReduxProvider>
);
